<template>
        <div class="d-block text-center">
            <div class="row no-margin mb-3">
                <div class="col-md-12">
                    <!--Vous allez effectuer un nouveau parametrage <br> pour l'outil : -->
                    <p>{{_props.system.name}} - Code : {{_props.system.code}} </p>
                </div>
            </div>
            <form @submit.prevent="calibrate_submit">

                <div class="row no-margin">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Type de mesure :</label>
                            <select v-model="sensor_type" id="sensorTypetSelection" class="form-control" @change="sensorTypeChanged">
                                <option v-bind:disabled="this.systemLinkedToVirtual" v-bind:selected="!this.systemLinkedToVirtual" value="1">Compte tour</option>
                                <option v-bind:disabled="this.systemLinkedToVirtual" value="2">PTO</option>
                                <option v-bind:disabled="this.systemLinkedToVirtual" value="4">Contact sec</option>
                                <option v-bind:disabled="this.systemLinkedToVirtual" value="5">Train d'impulsions</option>
                                <option v-bind:disabled="this.systemLinkedToVirtual" value="7">Impulsions</option>
                                <option v-bind:disabled="this.systemLinkedToVirtual" value="6">Vibration</option>
                                <option v-bind:disabled="this.systemLinkedToVirtual" value="9">Présence 9..24V</option>
                                <option v-bind:disabled="!this.systemLinkedToVirtual" v-bind:selected="this.systemLinkedToVirtual" value="10">Virtuel Absolu</option>
                                <option v-bind:disabled="!this.systemLinkedToVirtual" value="11">Virtuel Relatif</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="row no-margin">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>Veuillez préciser les paramètres de calibration :</label>
                            <select v-model="title" id="systemUnitSelection" class="form-control">
                                <option selected value="0">Unités</option>
                                <option value="1">Surface (hect)</option>
                                <option value="2">Distance (km)</option>
                                <option v-bind:disabled="this.systemLinkedToVirtual" value="4">Durée d'utilisation compteur(h)</option>
                                <option value="5">Energie (kWh)</option>
                                <option value="8">Volume(L)</option>
                                <option value="6">Volume(m³)</option>
                                <option value="7">Poids (kg)</option>
                                <option value="10">Durée depuis valeur (h)</option>
                            </select>
                        </div>
                    </div>
                </div>
                
                <div v-if="(title == 1) || (title == 2)">
                    <div class="row no-margin" v-if="title == 1">
                        <div class=" col-md-6">
                            <div class="form-group">
                                <label>Diamètre de roue</label>
                                <div class="input-group">
                                    <input v-model="tyre_size"
                                        type="number"
                                        step=any
                                        min="0"
                                        placeholder="Diamètre en "
                                        aria-describedby="wheelUnitSelection"
                                        class="form-control w-70"
                                        required
                                        v-bind:enabled="(factor != 0) && (tyre_size == 0 && working_width == 0)">

                                    <select v-model="wheel_unit" id="wheelUnitSelection" class="form-control w-30">
                                        <option selected value="0">m</option>
                                        <option value="1">inch</option>
                                    </select>
                                </div>
                            </div> 
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Largeur de travail (m)</label>
                                <form class="form-inline" >
                                    <input v-model="working_width"
                                        type="number"
                                        step=any
                                        min="0"
                                        placeholder="Largeur totale en metres"
                                        class="form-control"
                                        required
                                        v-bind:enabled="(factor != 0) && (tyre_size == 0 && working_width == 0)">
                                </form>    
                            </div>
                        </div>
                    </div>
                    
                    <div class="row no-margin" v-if="title == 2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Diamètre de roue</label>
                                <div class="input-group">
                                    <input v-model="tyre_size"
                                        type="number"
                                        step=any
                                        min="0"
                                        placeholder="Diamètre en "
                                        aria-describedby="wheelUnitSelection"
                                        class="form-control w-70"
                                        required
                                        v-bind:enabled="(factor != 0) && (tyre_size == 0 && working_width == 0)">

                                    <select v-model="wheel_unit" id="wheelUnitSelection" class="form-control w-30">
                                        <option selected value="0">m</option>
                                        <option value="1">inch</option>
                                    </select>
                                </div>
                            </div> 
                        </div>
                    </div>
                    <button type="button" v-on:click="compute_factor" class="btn btn-primary"  v-bind:disabled="((tyre_size <= 0) || (working_width <= 0 && title == 1))">Calculer</button> 
                    <div class="row no-margin">
                        <div class="col">
                            <hr>
                        </div>
                        <div class="col-md-1">
                        </div>
                        <div class="col">
                            <hr>
                        </div>
                    </div>
                        
                    <div class="row no-margin" v-if="title == 1">
                        <div class="col-md-12">
                            <div class="form-group">
                                    <label>Facteur (Unité/Hectare)</label>
                                    <input v-model="factor"
                                        name="facteur"
                                        type="number"
                                        step=any
                                        min="0"
                                        placeholder="Facteur"
                                        class="form-control"
                                        required
                                        v-bind:enabled="(tyre_size != 0 || working_width != 0)">                                    
                            </div>
                        </div>
                    </div>
                    <div class="row no-margin" v-if="title == 2">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Facteur (Unité/Km)</label>
                                <input v-model="factor"
                                        type="number"
                                        step=any
                                        min="0"
                                        placeholder="Facteur"
                                        class="form-control"
                                        required
                                        v-bind:enabled="(tyre_size != 0)">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="(title == 5) || (title == 6) || (title == 8) || (title == 10)">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label v-if="title == 5">Facteur (Unité/kWh)</label>
                            <label v-if="title == 6">Facteur (Unité/m³)</label>
                            <label v-if="title == 7">Facteur (Unité/kg)</label>
                            <label v-if="title == 8">Facteur (Unité/L)</label>
                            <label v-if="title == 10">Facteur (Unité/h)</label>
                            <input v-model="factor"
                                name="facteur"
                                type="number"
                                step=any
                                min="0"
                                placeholder="Facteur"
                                class="form-control"
                                required>                                    
                        </div>
                    </div>
                </div>
                <div  class="form-group">
                <label>Prix/{{getComputedValue}} :</label>
                    <div class="col-md-12">
                        <div class="input-group">
                            <input v-model="converted_price"
                                        name="converted_price"
                                        type="number"
                                        step=any
                                        min="0"
                                        placeholder="Facturation"
                                        aria-describedby="systemPriceSelection"
                                        class="form-control w-60"
                                        required>
                                        
                            <select v-model="price_unit" id="systemPriceSelection" class="form-control w-40">
                                <option selected value="0">€ (euro)</option>
                                <option value="1">$ (dollar)</option>
                                <option value="2">£ (livre sterling)</option>
                            </select>
                        </div>
                        <span id="error-price" v-if="error_converted_price" style="color: red;"> La valeur saisie est invalide </span>   
                    </div>
                </div>
  
                <div  class="form-group" >
                    <label>
                        Durée max de réservation :
                        <input type="checkbox" v-model="rentalMaxTimeEnabled">
                        <span :style="{ color: rentalMaxTimeEnabled ? 'rgba(0, 128, 0, 0.5)' : 'black' }"  v-if="rentalMaxTimeEnabled"> Activé </span>
                        <span v-else> Désactivé </span>
                    </label>
                    <div class="col-md-12">
                        <div class="input-group">
                            <input v-model="rental_max_lenght" 
                                @keypress="check_input($event)"
                                id="input_rental_max_lenght"
                                type="number"        
                                min="0"
                                class="form-control w-60"
                                placeholder="durée"
                                :disabled="!rentalMaxTimeEnabled"    
                                required>
                                
                            <select v-model="duree_unit" id="duree_unit" class="form-control w-40" :disabled="!rentalMaxTimeEnabled" required  >
                                <option disabled v-bind:value="null" selected>Choisissez une unité</option>
                                <option value="1">jour</option>
                                <option value="2">heure</option>
                                <option value="3">minute</option>
                                <option value="4">seconde</option>
                            </select>
                        </div>
                        <span id="error-rental-max-lenght" v-if="error_rental_max_lenght" style="color: red;"> La valeur saisie est invalide </span>
                    </div>
                </div>

                <div class="row no-margin">
                    <div class="col-md-12">
                        <div class="form-group">
                            <!--<label>Empreinte carbone(Kg CO2/{{this.unit_t}}) :</label>-->
                            <label>Empreinte carbone(Kg CO2/{{getComputedValue}}) :</label>
                            <input type="number" id="empreinte_CO2" class="form-control border-color not-allowed " 
                               @keypress="check_input($event)"
                               @paste="check_paste($event)"
                                placeholder="Entrer l'empreinte carbone du matériel (Kg CO2)" 
                                min="0"
                                v-model="empreinte_CO2"
                                maxlength="10"
                                step="0.0001"
                                title="au moins un chiffre avant la virgule et au plus 4 chiffres après la virgule "
                                required
                            >
                            <span id="error-empreinte_CO2" v-if="error_empreinte" style="color: red;"> La valeur saisie est invalide </span>
                                <!--pattern="^\d+(\.\d{1,4})?$"-->
                        </div>
                    </div>
                </div>
                <div class="row no-margin" v-if="((_props.system.sensor != null && sensor_type != _props.system.sensor.type) || (_props.system.sensor == null && sensor_type != _props.system.sensor_type)) && _props.system.sensor != null">
                    <label v-if="sensor_type != 10 && sensor_type != 11" style="color:red">Attention, le type de mesure demandée par la calibration est différente du type de compteur. Si vous validez, le système ne sera plus affecté au compteur actuel</label>
                    <label v-else style="color:red">Attention, le type de compteur virtuel est différent de celui qui est configuré actuellement. Le modifier engendrera un changement de la manière dont les messages sont interprétés</label>

                </div> 
                   
                <div class=" mrg-top-5">  
                    <button type="button" v-on:click="calibrate_cancel" class="btn btn-default">Annuler</button>
                    <b-button type="button"  variant="warning" v-on:click="open_alert" class="btn btn-default">Alertes</b-button>
                    <button 
                        type="submit" 
                        class="btn" 
                        v-bind:class="[(((_props.system.sensor != null && sensor_type != _props.system.sensor.type) || (_props.system.sensor == null && sensor_type != _props.system.sensor_type)) && _props.system.sensor != null) ? 'btn-outline-danger' : 'btn-primary']" 
                        v-bind:disabled="(title ==2 && (tyre_size == 0) && (factor == 0) )||
                                        (title ==1 && ((tyre_size == 0 || working_width == 0) && (factor == 0)))||
                                        ((title == 5 || title == 6 || title == 7) && (factor == 0))">
                            Valider
                    </button>
                    
                </div>
                <div class="alert alert-danger" role="alert" v-if="error">
                    Une erreur est surevenue ! Veuillez contacter KEMTAG!
                    <i class="ti-close float-right mt-1" @click="error = false"></i>
                </div> 
            </form>
<!----------------------------------------------------------------------------------------------------------------->
        
        <b-modal ref="alertes_popup" hide-footer centered no-close-on-backdrop hide-header-close v-bind:title="'Alertes '+system.name">
            <v-sys-warning
                :selected_system="system"
                @alert-done = "close_alert"
            ></v-sys-warning>
        </b-modal>
    </div>
</template>


<script>
    import api from "../../config/_api";
    import SystemWarnings from "../../components/System/SystemWarnings.vue";
  
    export default {
        name: "Index",
        components:{
            'v-sys-warning': SystemWarnings,
        },
        data () {
            return {
                error_converted_price: false,
                error_rental_max_lenght: false,
                error_empreinte: false,
                error: false,
                rental_max_lenght: null,
                rental_max_lenght_en_seconde: null,
                computed_status: null,
                duree_unit: null,
                rentalMaxTimeEnabled: false,
                sensor_type: 0,
                initial_rentalMaxTimeEnabled: 0,
                title: 1,
                tyre_size: 0,
                working_width: 0,
                factor: 0,
                wheel_unit : 0,
                price_unit: 0,
                unit_t: null,
                unit: null,
                empreinte_CO2 :0,
                rental_max_lenght_mask : 0x80,
                converted_price: 0,
                initial_converted_price: 0,
                initial_empreinte_CO2: 0,
                initial_rental_max_lenght:0,
                systemLinkedToVirtual:false
            }
        },
        props: {
            system: {
                type: Object,
                required: true,
                default: function () {
                    return { 
                        id: 1,
                        name: "",
                        code: ""
                    }
                }
            }
        },
        created() {
            this.analyse_status();
            this.unite();
            this.setValues();
        },
        computed: {
            getComputedValue(){
                return this.setValues(this.title);
            }
            
        },
        mounted() {
            this.sensor_type = 0;
            this.title = 1;
            this.tyre_size = 0;
            this.working_width = 0;
            this.factor = 0;
            this.wheel_unit = 0;
            this.price_unit = 0;
            this.converted_price = 0;
            this.empreinte_CO2 = this._props.system.empreinte_CO2;
            if(this._props.system!=null){
                //recuperation des valeur initiales des inputs pour comparaison avec "" dans le submit
                this.initial_converted_price = this._props.system.converted_price_factor;
                this.initial_rental_max_lenght = this._props.system.rental_max_lenght;
                this.initial_empreinte_CO2 = this._props.system.empreinte_CO2;
                if((this._props.system.status & this.rental_max_lenght_mask)>0){
                    this.initial_rentalMaxTimeEnabled = 1;
                }
                else{
                    this.initial_rentalMaxTimeEnabled = 0;  
                }
            }
            if(this._props.system.rental_max_lenght !=0){
                if(this._props.system.rental_max_lenght % 86400 === 0){
                    this.rental_max_lenght = this._props.system.rental_max_lenght/86400;
                    this.duree_unit = 1;
                }
                else if (this._props.system.rental_max_lenght % 3600 === 0 && this._props.system.rental_max_lenght % 86400 !== 0) {
                    this.rental_max_lenght = this._props.system.rental_max_lenght/3600;
                    this.duree_unit = 2;
                }
                else if (this._props.system.rental_max_lenght % 60 === 0 && this._props.system.rental_max_lenght % 3600 !== 0 && this._props.system.rental_max_lenght % 86400 !== 0) {
                    this.rental_max_lenght = this._props.system.rental_max_lenght/60;
                    this.duree_unit = 3;
                }
                else {
                    this.rental_max_lenght = this._props.system.rental_max_lenght;
                    this.duree_unit = 4;
                }
            }
            this.title = parseInt(this._props.system.display_unit.title);
            this.sensor_type = parseInt(this._props.system.sensor_type)
            if (this._props.system.display_unit.tyre_size != null) {
                this.tyre_size = this._props.system.display_unit.tyre_size;
            }
            if (this._props.system.display_unit.working_width != null) {
                this.working_width = this._props.system.display_unit.working_width;
            }
            if (this._props.system.display_unit.factor != 1) {
                this.factor = this._props.system.display_unit.factor;
            }
            if (this._props.system.display_unit.factor == 1) {
                this.factor = this._props.system.display_unit.factor;
            }
            this.price_unit = parseInt(this._props.system.price_unit);
            this.converted_price = parseFloat(this._props.system.converted_price_factor);

            if(this._props.system.sensor != null){
                if(this._props.system.sensor.type == 10 || this._props.system.sensor.type == 11){
                    this.systemLinkedToVirtual = true;
                }
            }
        },
        methods: {
            //mise à jour du status en fonction de la durée max de reservation cochée ou pas
            updateStatus() {
                if (this.initial_rentalMaxTimeEnabled!= this.rentalMaxTimeEnabled){
                    if(this.rentalMaxTimeEnabled == 1){
                        this.computed_status = this._props.system.status + this.rentalMaxTimeEnabled*this.rental_max_lenght_mask;
                        return this.computed_status;
                    }
                    else{
                        this.computed_status = this._props.system.status - this.initial_rentalMaxTimeEnabled*this.rental_max_lenght_mask;
                        return this.computed_status;
                    }
                }
                else{
                    this.computed_status = this._props.system.status;
                    return this.computed_status;
                }
            },
            analyse_status(){
                if(this._props.system!=null){
                    if((this._props.system.status & this.rental_max_lenght_mask)>0){
                        this.rentalMaxTimeEnabled = 1;
                    }
                    else{
                       this.rentalMaxTimeEnabled = 0;  
                    }
                }
            },
            compute_factor(){
                if(this.wheel_unit==1){this.tyre_size = this.tyre_size*0.0254; this.wheel_unit = 0;}
                if(this.title==1){this.factor =  1/(3.14159265359 *this.tyre_size * this.working_width*0.0001);}  //
                if(this.title==2){this.factor =  1/(3.14159265359 *this.tyre_size*0.001);}      //Pour passer en km
            },
            unite(){
                if(this._props.system!=null){
                    this.$store.dispatch('display_unit/getUnit', {
                        id: this._props.system.display_unit_id,
                    }).then(resp => {
                        const unit = resp.title;
                        this.setValues(unit);
                    }).catch((error) => {
                        this.error = true;
                    })
                }
            },
            open_alert() {
                this.system = this._props.system;
                //TODO décommenter la ligne dès que tout les scripts de traiements seront terminés
                this.$refs.alertes_popup.show();
            },
            close_alert(resp){
                this.$refs.alertes_popup.hide();
                if (resp!=null){
                    this._props.system.status= resp.resp.data.status;
                }
            },
            setValues(unit){
                if(unit=='0'){
                    this.unit_t= 'unité';
                }	
                else if(unit=='1'){
                    this.unit_t= 'hectare';
                }	
                else if(unit=='2'){
                    this.unit_t= 'kilomètre';
                }
                else if(unit=='3'){
                    this.unit_t= 'contact';
                }
                else if(unit=='4'){
                    this.unit_t= 'heure';
                }
                else if(unit=='5'){
                    this.unit_t= 'Kwh';
                }
                else if(unit=='6'){
                    this.unit_t= 'm³';
                }
                else if(unit=='7'){
                    this.unit_t= 'kg';
                }
                else if(unit=='8'){
                    this.unit_t= 'L';
                }
                else if(unit=='10'){
                    this.unit_t= 'h';
                }
                return this.unit_t;
            },
         
            check_input(event) {
                if ((event.key === '+')||(event.key === '-')) {
                    event.preventDefault();
                }
            },
            
            check_paste(event) {
                event.stopPropagation();
                event.preventDefault();
            },
            calibrate_cancel() {
                this.$emit('calibration-done')
            },
            calibrate_submit() {
                this.error_empreinte =false;
                this.error_converted_price= false;
                this.error_rental_max_lenght = false;

                if((this.initial_empreinte_CO2!= this.empreinte_CO2) && (this.empreinte_CO2 ==="")){ //car si on a 0 ca fait une erreur
                    this.error_empreinte = true;
                }
                if((this.initial_rental_max_lenght != this.rental_max_lenght) && (this.rental_max_lenght === "") && (this.rentalMaxTimeEnabled == 1)){
                    this.error_rental_max_lenght = true;
                }
                if((this.initial_converted_price !== this.converted_price ) && (this.converted_price === "")){
                    this.error_converted_price = true;
                }
                if((this.error_converted_price== true)||(this.error_rental_max_lenght== true)||(this.error_empreinte==true)){
                    return;
                }

                if (this.title == 2) {
                    this.working_width = 0.1;
                }
                if (this.empreinte_CO2 == ""){
                    this.empreinte_CO2 = "0";
                }
                //conversion de la duree resa en seconde
                if (this.rental_max_lenght!== ""){
                    if(this.duree_unit == 1){
                        this.rental_max_lenght_en_seconde =this.rental_max_lenght*86400;
                    }
                    if(this.duree_unit == 2){
                        this.rental_max_lenght_en_seconde =this.rental_max_lenght*3600;
                    }
                    if(this.duree_unit == 3){
                        this.rental_max_lenght_en_seconde =this.rental_max_lenght*60;
                    }
                    if(this.duree_unit == 4){
                        this.rental_max_lenght_en_seconde =this.rental_max_lenght;
                    }
                }
                //envoie de la valeur precedente si on a une valeur invalide de rental_max_lenght et rentalMaxTimeEnabled desactiver
                if((this.rental_max_lenght=== "") && (this.rentalMaxTimeEnabled== 0)){
                    this.rental_max_lenght_en_seconde = this._props.system.rental_max_lenght;
                }
                
                let data = {
                    title: this.title,
                    tyre_size: this.tyre_size,
                    working_width: this.working_width,
                    factor: this.factor,
                    structure_id: this.$store.getters.structure_id,
                    converted_price_factor: this.converted_price,
                    empreinte_CO2 : this.empreinte_CO2,
                    rental_max_lenght: this.rental_max_lenght_en_seconde,
                    status: this.updateStatus(),
                    price_unit: this.price_unit
                };

                // console.log(data);
                var type = 1;
                if((this.title == 1)||(this.title == 2)) {
                    if(this.factor != 0) {
                        type = 2
                    } else {
                        type = 3;
                    }
                }
                if((this.title == 5)||(this.title == 6)||(this.title == 7)||(this.title == 8)||(this.title == 10)){
                    type = 4;
                }

                let url = api.url + 'systems/calibrate/' + this._props.system.id + '/' + type + '/' + this.sensor_type + '?structure_id=' + this.$store.getters.structure_id;

                this.axios({url: url, data: data, method: 'POST' })
                    .then(resp => {
                        if(resp.status <400){
                            this.$emit('calibration-done')
                        }
                    })
                    .catch(err => {
                        this.error = true;
                       //console.log(err);
                    });
            },
            sensorTypeChanged() {
                //if((this.sensor_type == 5 || this.sensor_type == 6 || this.sensor_type == 7) && (this.title == 1 || this.title == 2)){
                    this.title = 0;
                //}
            }
        }
    }
</script>

<style>

.w-30{
    width : 30% !important;
}
.w-40{
    width : 40% !important;
}

.w-60{
    width : 60% !important;
}

.w-70{
    width : 70% !important;
}

.no-margin{
    display: flex;
    margin-left : 0;
    margin-right : 0;
}


</style>